import QuotationUIModel from './quotations';

export default class QuoteRefundUIModel {
  constructor({
    applyReinstatementFee = false,
    clubPremier = {
      boletoPremiaType: '',
      miles: '',
      reinstallFeeAmount: '',
      voucherInfo: {
        found: false,
        number: '',
        expiry: '',
      },
    },
    cuentaPremier = '',
    driver = {
      actionType: '',
      applicationClient: '',
      applicationMode: '',
    },
    fops = [],
    hasAssistCard = false,
    quotations = [],
    quoteRefundResult = {
      reason: '',
      code: '',
      description: '',
      subCode: '',
    },
    recordLocator = '',
  }) {
    this.applyReinstatementFee = applyReinstatementFee;
    this.clubPremier = clubPremier;
    this.cuentaPremier = cuentaPremier;
    this.driver = driver;
    this.fops = fops;
    this.hasAssistCard = hasAssistCard;
    this.quotations = quotations.map(quotation => new QuotationUIModel(quotation));
    this.quoteRefundResult = quoteRefundResult;
    this.recordLocator = recordLocator;
  }
}
